const styles = {
  spacing: {
    "grid-system-space-025": "2px",
    "grid-system-space-050": "4px",
    "grid-system-space-075": "6px",
    "grid-system-space-100": "8px",
    "grid-system-space-150": "12px",
    "grid-system-space-200": "16px",
    "grid-system-space-300": "24px",
    "grid-system-space-400": "32px",
    "grid-system-space-500": "40px",
    "grid-system-space-600": "48px",
    "grid-system-space-700": "56px",
    "grid-system-space-800": "64px",
    "grid-system-space-900": "72px",
    "grid-system-space-1000": "80px",
    "grid-system-space-1200": "96px",
    "grid-system-space-1500": "120px",
  },
};
export default styles;
